import * as angular from "angular";

let LimitUsed = {
    selector: "vcLimitUsed",
    templateUrl: "/angular/components/admin/limit-used.component.html",
    bindings: {
        used: "=",
        included: "=?",
        extra: "=?",
    },
    controller: class LimitUsedController {
        // * bindings for typescript compiler *
        public used: any;
        public included?: any;
        public extra?: any;
        // ************************************

        formatNum(number?: string) {
            return number ? parseInt(number) : 0;
        }

        totalLimit(): number {
            if (!this.included && !this.extra) {
                return 0;
            }
            return this.formatNum(this.included) + this.formatNum(this.extra);
        }

        percentageUsed(): number {
            if (!this.totalLimit()) {
                return 0;
            }
            return (this.formatNum(this.used) / this.totalLimit()) * 100;
        }
    },
};

angular.module("admin").component(LimitUsed.selector, LimitUsed);
